import { REQUEST } from 'Stores'
import { BLOCK_OR_ACTIVE_USER, GET_ALL_PORTFOLIO_BY_USER_ID, GET_INFO_USER_AND_PORTFOLIO, GET_USER_LIST } from './constants'

export function getUserList(payload) {
  return {
    type: REQUEST(GET_USER_LIST),
    payload
  }
}

export function blockOrActiveUser(payload) {
  return {
    type: REQUEST(BLOCK_OR_ACTIVE_USER),
    payload
  }
}

export function getAllPortfolioByUserId(payload) {
  return {
    type: REQUEST(GET_ALL_PORTFOLIO_BY_USER_ID),
    payload
  }
}

export function getInfoUserAndPortfolio(payload) {
  return {
    type: REQUEST(GET_INFO_USER_AND_PORTFOLIO),
    payload
  }
}
